export default __webpack_public_path__ + "static/media/040_tunnel.last.f86a2859.png";